// Commented out DW - switching to hatch service
/*$(function() {
  $('.mc-contact-form').submit(function(e) {
    e.preventDefault();
    var email = $('.contact_email',$(this)).val();
    if (!valid_email_address(email)){
      $.magnificPopup.open({
        items: {
          src: '<div class="white-popup">'+'The email address you entered was invalid. Please make sure you enter a valid email address to subscribe.'+'</div>', // can be a HTML string, jQuery object, or CSS selector
          type: 'inline'
        }
      });
    }
    else{
      $.getJSON("//hatch-baby.timetoduckandcover.com/subscribe.php?callback=?&send_welcome=0",
                'email='+email,
                function(result){
        //response data are now in the result variable
        console.log(result);
        if(result.status == 0 ){
          $('.mc-contact-form').html("<span style='color:#333333'>"+result.message+"</span>");
        }
        else{
          $.magnificPopup.open({
            items: {
              src: '<div class="white-popup">'+result.message+'</div>', 
              type: 'inline'
            }
          });  
        }
      });

    }
    return false;
  });
*/

$(function() {

  var QueryString = function () {
    // This function is anonymous, is executed immediately and 
    // the return value is assigned to QueryString!
    var query_string = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
          // If first entry with this name
      if (typeof query_string[pair[0]] === "undefined") {
        query_string[pair[0]] = decodeURIComponent(pair[1]);
          // If second entry with this name
      } else if (typeof query_string[pair[0]] === "string") {
        var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
        query_string[pair[0]] = arr;
          // If third or later entry with this name
      } else {
        query_string[pair[0]].push(decodeURIComponent(pair[1]));
      }
    } 
      return query_string;
  }();
  
  $('.mc-contact-form').submit(function(e) {
    e.preventDefault();
    var email = $('.contact_email',$(this)).val();
    var product = $('.product',$(this)).val();
    var utm_campaign = QueryString.utm_campaign;
    var utm_source = QueryString.utm_source;
    var utm_medium = QueryString.utm_medium;
    if(typeof utm_source == 'undefined'  || utm_source == null) utm_source = 'direct';
    if(typeof utm_campaign == 'undefined'  || utm_campaign == null) utm_campaign = '';
    if(typeof utm_medium == 'undefined'  || utm_medium == null) utm_medium = '';
    if (!valid_email_address(email)){
      $.magnificPopup.open({
        items: {
          src: '<div class="white-popup">'+'The email address you entered was invalid. Please make sure you enter a valid email address to subscribe.'+'</div>', // can be a HTML string, jQuery object, or CSS selector
          type: 'inline'
        }
      });
    }
    else{
//      $.post('https://data.hatchbaby.com/public/member/v1/signup', JSON.stringify({"email" : email}));
     $.ajax({
  			type: 'POST',
  			url: 'https://data.hatchbaby.com/public/member/v1/signup',
  			contentType: 'application/json',
  			dataType: 'json',
       		data: JSON.stringify({"email" : email, "utm_campaign": utm_campaign, "utm_source": utm_source, "utm_medium": utm_medium, "product": product})
	  }); 

          $('.mc-contact-form').html("<span style='color:#333333'>Thanks! We'll keep you in the loop!</span>");
 
        }
    return false;
  });  


  function valid_email_address(email)
  {
    var pattern = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
    return pattern.test(email);
  }



  $win = $(window);
  $win.scroll(function () {
    if ($win.scrollTop() <= 0){
      if($(window).width() <= 767){
        $('.hide-me').show();
      }
    }
    else{
      $('.hide-me').hide();
    }
    /*
      if ($win.scrollTop() - 50 < 0){
        $('.site-header').removeClass('white-header');
      }
      else{
        $('.site-header').addClass('white-header');
      }
    */
  });
  /*
    if ($win.scrollTop() - 50 < 0){
      $('.site-header').removeClass('white-header');
    }
    else{
      $('.site-header').addClass('white-header');
  	}
  */
  
  
  // Add padding above first two homepage images 
  function whitespaceImages() {
  	if ($(window).width() >= 1200) { 
      $('.iphone-images:lt(2)').css({"padding-top" : "110px"});
    } else {
      $('.iphone-images').css({"padding-top" : "0"});
    }
  }
  whitespaceImages();
  window.onresize = function(event) {
   	whitespaceImages();
  };
  
  //var poster = $('#bgvid').attr('poster');
  //$('.home-hero').css({"background-image" : "url(http:" + poster + ")"});
  
//   $('#bgvid').bind('ended', function(){
//     $(this).fadeOut();
//   }); 

});